<section class="hero-section">
    <div class="hero-background">
        <!-- Background gradient overlay -->
        <div class="gradient-overlay"></div>

        <!-- Animated particles/effects (optional) -->
        <div class="particles"></div>
    </div>

    <div class="container">
        <div class="row align-items-center">
            <!-- Left Content -->
            <div class="col-lg-6 col-md-12">
                <div class="hero-content">
                    <h1 class="hero-title">
                        Level Up Your Game.<br>
                        Rule The Arena.
                    </h1>

                    <p class="hero-description">
                        <span class="highlight">Step into YoGamez Hub.</span> Play the hottest games, join tournaments, earn rewards, and connect with gamers across Zimbabwe and beyond.
                    </p>

                    <div class="hero-buttons">
                        <button class="btn btn-primary" (click)="playNow()">PLAY NOW</button>
                        <button class="btn btn-secondary" (click)="joinNow()">JOIN NOW</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
